import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { lettersQueryOptions } from '@heidi/integrations/letters/data';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';

import type { ObjectReference } from './chat-object-reference-hooks';
import { referenceLabels, referenceSummaries } from './chat-object-reference-label';

// There is no letter-by-id read; the session's list is shared with the letter panel.
export const useLetterReference = (id: string, sessionId: string): ObjectReference => {
  const intl = useIntl();
  const { isAuthenticated } = useIsAuthenticated();
  const query = useQuery({
    ...lettersQueryOptions(sessionId),
    enabled: isAuthenticated,
    select: (letters) => letters.find((letter) => letter.id === id),
  });
  const label = referenceLabels.letter(query.data);
  return {
    query,
    label,
    summary:
      label && query.data
        ? referenceSummaries.letter(label, query.data, intl)
        : undefined,
  };
};
